import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_CONTAINER_TRACKINGS:
      return { ...action.containerTrackings };
    case Action.CLEAR_CONTAINER_TRACKINGS:
      return {};
    default:
      return state;
  }
};
